import React, { useState, useEffect, useContext } from "react";
import { useHistory, Link } from "react-router-dom";
import { Resizable } from "re-resizable";
import { list_questions } from "../../../services/questions";
import { Container, Content, NoDocumentProvided } from "./styles";
import AnalistChecklist from "../../../components/AnalistChecklist";
import QuestionContext from "../../../contexts/QuestionContext";

interface ListProps {
	title: string;
	id: number;
	documentsTag: { id: string; name: string }[];
}

function StepThree() {
	const [checkRejecteds, setCheckRejecteds] = useState<number[]>([]);

	// Ver comentarios no contexto para entender
	const { setStepThreeValues, documents } = useContext(QuestionContext);

	const [selectedDocQuestions, setSelectedDocQuestions] = useState<any>([]);
	const [selectedDocument, setSelectedDocument] = useState(documents[0]);

	useEffect(() => {
		(async () => {
			const listQuestions = await list_questions(1);
			const questions = listQuestions.data;
			const filteredQuestions = questions.filter((question: any) => {
				const questionTags = question.documentsTag.map(
					(tag: any) => tag.id,
				);
				return questionTags.includes(selectedDocument.documentTagId);
			});
			setSelectedDocQuestions(filteredQuestions);
		})();
	}, [selectedDocument]);

	const history = useHistory();
	const backButton = () => {
		let link = history.location.pathname;
		link = link.replace("/step-three", "/step-two");

		history.push(link);
	};

	const handleCheckRejected = (id: number) => {
		const newCheckRejecteds = [...new Set([...checkRejecteds, id])];
		setCheckRejecteds(newCheckRejecteds);
	};

	const handleAnswer = (id: number, answer: number) => {
		if (answer === 2) if (id) handleCheckRejected(id);
		setStepThreeValues((state: any) => ({
			...state,
			...{
				[selectedDocument.id]: {
					...state[selectedDocument.id],
					...{ [id]: { answer } },
				},
			},
		}));
	};

	const handleJustificationChange = (id: number, justification: string) => {
		setStepThreeValues((state: any) => ({
			...state,
			[selectedDocument.id]: {
				...selectedDocument.id,
				[id]: { answer: 2, justification },
			},
		}));
	};

	return (
		<Container>
			<Content>
				<Resizable
					defaultSize={{ width: "50%", height: "100%" }}
					minWidth={"35%"}
					maxWidth={"60%"}
					minHeight={"100%"}
					maxHeight={"100%"}>
					<div className='content-wrapper'>
						<div className='header-wrapper'>
							<div className='header'>
								<p className='txt-header'>Consulta</p>
								<p>
									Preencha as perguntas para completar o
									checklist
								</p>
							</div>
							<div className='docs-wrapper'>
								{documents
									?.filter((doc: any) => doc.documentTagId)
									.map((item: any) => {
										return (
											<div
												className={`doc ${
													selectedDocument?.documentTagId ===
														item?.documentTagId &&
													"selected"
												}`}
												key={item.id}
												onClick={() => {
													setSelectedDocument(item);
												}}>
												<p>{item?.documentTag?.name}</p>
											</div>
										);
									})}
							</div>
						</div>
						<div className='quest-wrapper'>
							{selectedDocQuestions.length
								? selectedDocQuestions.map(
										(item: ListProps) => {
											return (
												<AnalistChecklist
													title={item.title}
													id={item.id}
													key={`${selectedDocument.id} - ${item.id}`}
													selectedDocumentId={
														selectedDocument.id
													}
													handleAnswer={(
														value: number,
													) => {
														handleAnswer(
															item.id,
															value,
														);
													}}
													handleJustificationChange={
														handleJustificationChange
													}
												/>
											);
										},
								  )
								: "Não possui perguntas vinculadas a este documento"}
						</div>
						<div className='button-wrapper'>
							<button onClick={backButton} id='cancel-button'>
								Voltar
							</button>
							<Link to={`/step-four`}>
								<button>Próxima Etapa</button>
							</Link>
						</div>
					</div>
				</Resizable>
				{document?.location ? (
					<div className='doc-side'>
						<iframe
							src={selectedDocument?.location}
							frameBorder={0}
							title='docs_frame'
						/>
					</div>
				) : (
					<NoDocumentProvided>
						<p>
							A tag selecionada ainda não possui documentos
							vinculados, por favor voltar a etapa anterior para
							vincular o documento a tag.
						</p>
						<button onClick={backButton} id='cancel-button'>
							Voltar
						</button>
					</NoDocumentProvided>
				)}
			</Content>
		</Container>
	);
}

export default StepThree;
